import React, { useState, useEffect } from 'react';
import './OneToOneAdd.css'; 
// import './Addmeetings.css';
import './adduser.css';

const AddMeetings = () => {
  const [maxDate, setMaxDate] = useState('');

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];
    setMaxDate(today);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const date = formData.get('date');
    const userId = localStorage.getItem('userId');

    const data = {
      date: date,
      userId: userId // Include user _id from localStorage
    };

    try {
      const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/meeting', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (response.ok) {
        alert('Attendance added successfully');
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while adding the attendance.');
    }
  };

  return (
    <>
      <div className="contain">
        {/* Main Content */}
        <main className="main-content">
          <div className="form-containerOne">
            <h2 className='name'>Add Attendance Date</h2>
            <form id="userForm" onSubmit={handleSubmit}>
              <div className="form-group1">
                <input type="date" id="date" name="date" placeholder="Date" required max={maxDate} />
              </div>
              <button type="submit" className="btnOne">Add Attendance Date</button>
            </form>
          </div>
        </main>
      </div>
    </>
  );
};

export default AddMeetings;
